module.exports = __webpack_public_path__ + "img/logo.66018ed0.svg";